module.exports = __webpack_public_path__ + "images/active-p.5c046ece78fd59838cd6ff40fd34324b.png";